var Component = require("!../../../../_vue-loader@11.3.4@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../_vue-loader@11.3.4@vue-loader/lib/selector?type=script&index=0!./form-item.vue"),
  /* template */
  require("!!../../../../_vue-loader@11.3.4@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2039ae56\"}!../../../../_vue-loader@11.3.4@vue-loader/lib/selector?type=template&index=0!./form-item.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin/~/_qfpay-element-ui@1.0.8@qfpay-element-ui/packages/form/src/form-item.vue
// module id = 801
// module chunks = 0